import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { votestats } from '../../../model/votestats'
import { Grafico } from './Grafico'

interface IProps {
    votestats: votestats;
    reloadVotes: () => any;
    classes: any;
}

export const VoteGraph = (props: IProps) => {
    const { votestats } = props;
    return (
        <Grid container className={props.classes.graphContainer}>
            <Typography>Votazione</Typography>
            {votestats && <Grafico dati={votestats} />}
        </Grid>
    );
}
